// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#browse-marketplace .v-toolbar{background:#fafafa!important;border-bottom:2px solid #f4f2f9!important}#browse-marketplace .custom-app-bar{border-bottom:none!important}#browse-marketplace .custom-app-bar,#browse-marketplace .custom-app-bar:hover{background-color:transparent!important}", ""]);
// Exports
module.exports = exports;
